export default "__VITE_ASSET__CBiRCa16__"